import { render } from "./emp-card.vue?vue&type=template&id=02252209"
import script from "./emp-card.vue?vue&type=script&setup=true&lang=js"
export * from "./emp-card.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/components/forms/org-structure-form/emp-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02252209"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02252209', __exports__)) {
    api.reload('02252209', __exports__)
  }
  
  module.hot.accept("./emp-card.vue?vue&type=template&id=02252209", () => {
    api.rerender('02252209', render)
  })

}


export default __exports__